import { ItemTypes } from './Map';
import { useDrop } from 'react-dnd';
import './sample.css';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { Tooltip } from '@mui/material';

const Well = ({
  index,
  moveSample,
  children,
  selectedSamples,
  setSwapRange,
  swapRange,
  errorActions,
}) => {
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: ItemTypes.WELL,
      canDrop: (item) => {
        if (selectedSamples.has(item._id) && index + selectedSamples.size > 96) {
          return false;
        }
        return true;
      },
      drop: (item, monitor) => moveSample(index, monitor.getItem()),
      hover: (item, monitor) => {
        setSwapRange({
          start: index,
          end: selectedSamples.has(item._id)
            ? index + selectedSamples.size - 1
            : index,
        });
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [index, selectedSamples]
  );

  const error = errorActions.getError(index);

  return (
    <div
      ref={drop}
      style={{
        borderStyle: 'solid',
        backgroundColor: 'white',
        height: '65px',
        width: '95px',
        position: 'relative',
      }}
      className={
        (swapRange.end <= 95 &&
          index >= swapRange.start &&
          index <= swapRange.end)
          ? 'dashed-border'
          : null
      }
    >
      {error ? (
        <Tooltip title={error} style={{ position: 'absolute', right: 0 }}>
          <ErrorRoundedIcon fontSize="12px" />
        </Tooltip>
      ) : null}

      {children}
    </div>
  );
};

export default Well;
